import React from "react";

function Dashboard() {
  return (
    <div className="admin-dashboard">
      <h3 className="admin-dashboard__title">Network</h3>
      <div></div>
    </div>
  );
}

export default Dashboard;
